import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';

const listItem = (query, value, errors, byId) => {
  const className = errors.includes(query.name) ? 'error' : 'aridhia-query-dropdown';
  const identifier = byId ? query.id : query.uuid;
  return {
    key: `query_dropdown_item_${identifier}`,
    text: query.name,
    value: identifier,
    active: identifier === value,
    className,
  };
};

const listItems = (queries, value, errors, byId) => queries.map(
  (query) => listItem(query, value, errors, byId),
);

const CohortQueryDropdown = ({
  byId,
  className,
  disabled,
  errors = [],
  inline,
  message,
  multiple,
  onChange,
  queries,
  readStatus,
  trigger,
  value,
}) => {
  const intl = useIntl();
  const selection = !inline && !trigger;
  return (
    <Dropdown
      disabled={disabled}
      placeholder={message ? intl.formatMessage({ id: message }) : null}
      onChange={onChange}
      multiple={multiple}
      loading={readStatus === states.PENDING}
      value={value}
      options={listItems(queries, value, errors, byId)}
      className={clsx('aridhia-queries-dropdown', className)}
      icon={trigger ? null : undefined}
      fluid={selection}
      selection={selection}
      direction={trigger ? 'left' : undefined}
      trigger={trigger}
      inline={inline}
      scrolling
    />
  );
};

export default CohortQueryDropdown;
